import SolidBtn from "../components/form/solidBtn.comp";
import Layout from "../components/layouts/layout.comp";
import ProfileLocale from "../components/profile/profileLocale";
import ProfileMe from "../components/profile/profileMe";
import { profileGridCss } from "../components/reuseables/native.comp";
import { useTranslation } from "../core/translation.core";
import useProfile from "../hooks/useProfile.hook";
import { getDomain, useCookies } from "../core/cookies.core";
import Cookies from "js-cookie";
import OutlineBtn from "../components/form/outlineBtn.comp";
import KeyIcon from "../icons/key.icon";
import ShopIcon from "../icons/shop.icon";
import SolidLink from "../components/form/solidLink.comp";

export default function SettingPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.setting.setting)}>
      <section data-type="section">
        <div className="flex gap-4">
          <ChangePwdBtn />
          <CreateShopButton />
        </div>
      </section>
      <section data-type="section" className="space-y-6">
        <ProfileMe />
        <ProfileLocale />
        {/* <OffHoursBtn /> */}
        <ToggleLogoButton />
      </section>
    </Layout>
  );
}

function CreateShopButton() {
  const { t, msg } = useTranslation();
  const { isSuperAdmin } = useProfile();

  if (!isSuperAdmin) return null;

  return (
    <SolidLink
      id="create-shop"
      className="bg-her-lightFrenchBeige"
      href="/shop/create"
      text={t(msg.shop.createShop)}
      icon={<ShopIcon className="w-5 h-5" />}
    />
  );
}

// function OffHoursBtn() {
//   const { t, msg } = useTranslation();

//   return (
//     <div>
//       <Link id="set-off-hours" className="underline" href="/user/offHours">
//         {t(msg.user.setOffHours)}
//       </Link>
//     </div>
//   );
// }

function ChangePwdBtn() {
  const { t, msg } = useTranslation();

  return <SolidLink id="change-pwd" href="/user/changePwd" text={t(msg.user.changePwd)} icon={<KeyIcon className="w-5 h-5" />} />;
}

const ToggleLogoButton = () => {
  const isClientLogo = useCookies("isClientLogo");
  const { isSuperAdmin } = useProfile();
  const { t, msg } = useTranslation();

  const handleToggle = async () => {
    if (isClientLogo) {
      Cookies.remove("isClientLogo", { domain: getDomain() });
      return;
    }

    Cookies.set("isClientLogo", "true", {
      domain: getDomain(),
      expires: 7,
      sameSite: "strict",
    });
  };

  return (
    <div className={profileGridCss}>
      <div>Toggle Logo</div>
      <div className="flex gap-4 items-center">
        <div>
          {isSuperAdmin && isClientLogo ? (
            <SolidBtn id="logo-her" onClick={handleToggle}>
              {t(msg.setting.showHerLogo)}
            </SolidBtn>
          ) : null}
          {isSuperAdmin && !isClientLogo ? (
            <OutlineBtn id="logo-client" onClick={handleToggle}>
              {t(msg.setting.showClientLogo)}
            </OutlineBtn>
          ) : null}
        </div>
      </div>
    </div>
  );
};
